export const ru = {
    ticketRemaining: {
        one: 'остался {count} билет',
        some: 'осталось {count} билета',
        many: 'осталось {count} билетов',
        none: '',
    },
    from: 'от',
};
